// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://soneium.blockscout.com/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://soneium.blockscout.com/address/0xEf323B194caD8e02D9E5D8F07B34f625f1c088f1
export const PROTOCOL_GUARDIAN = '0xEf323B194caD8e02D9E5D8F07B34f625f1c088f1';

export const CHAIN_ID = 1868;
